import * as React from 'react';

import ExportErrorPage from 'export/ExportErrorPage';
import ErrorBoundary from 'components/errors/ErrorBoundary';

const ExportErrorBoundary = ({ children }: React.PropsWithChildren) => (
  <ErrorBoundary FallbackComponent={ExportErrorPage}>{children}</ErrorBoundary>
);

export default ExportErrorBoundary;
